"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("../constants");

var results_1 = require("../../../results");

var dayjs_1 = __importDefault(require("dayjs"));

var AbstractParserWithWordBoundary_1 = require("../../../common/parsers/AbstractParserWithWordBoundary");

var pattern_1 = require("../../../utils/pattern");

var PATTERN = new RegExp("(dit|deze|komende|volgend|volgende|afgelopen|vorige)\\s*(".concat(pattern_1.matchAnyPattern(constants_1.TIME_UNIT_DICTIONARY), ")(?=\\s*)") + "(?=\\W|$)", "i");
var MODIFIER_WORD_GROUP = 1;
var RELATIVE_WORD_GROUP = 2;

var NLRelativeDateFormatParser = /*#__PURE__*/function (_AbstractParserWithWo) {
  _inherits(NLRelativeDateFormatParser, _AbstractParserWithWo);

  var _super = _createSuper(NLRelativeDateFormatParser);

  function NLRelativeDateFormatParser() {
    _classCallCheck(this, NLRelativeDateFormatParser);

    return _super.apply(this, arguments);
  }

  _createClass(NLRelativeDateFormatParser, [{
    key: "innerPattern",
    value: function innerPattern() {
      return PATTERN;
    }
  }, {
    key: "innerExtract",
    value: function innerExtract(context, match) {
      var modifier = match[MODIFIER_WORD_GROUP].toLowerCase();
      var unitWord = match[RELATIVE_WORD_GROUP].toLowerCase();
      var timeunit = constants_1.TIME_UNIT_DICTIONARY[unitWord];

      if (modifier == "volgend" || modifier == "volgende" || modifier == "komende") {
        var timeUnits = {};
        timeUnits[timeunit] = 1;
        return results_1.ParsingComponents.createRelativeFromRefInstant(context.refDate, timeUnits);
      }

      if (modifier == "afgelopen" || modifier == "vorige") {
        var _timeUnits = {};
        _timeUnits[timeunit] = -1;
        return results_1.ParsingComponents.createRelativeFromRefInstant(context.refDate, _timeUnits);
      }

      var components = context.createParsingComponents();
      var date = dayjs_1.default(context.refDate);

      if (unitWord.match(/week/i)) {
        date = date.add(-date.get("d"), "d");
        components.imply("day", date.date());
        components.imply("month", date.month() + 1);
        components.imply("year", date.year());
      } else if (unitWord.match(/maand/i)) {
        date = date.add(-date.date() + 1, "d");
        components.imply("day", date.date());
        components.assign("year", date.year());
        components.assign("month", date.month() + 1);
      } else if (unitWord.match(/jaar/i)) {
        date = date.add(-date.date() + 1, "d");
        date = date.add(-date.month(), "month");
        components.imply("day", date.date());
        components.imply("month", date.month() + 1);
        components.assign("year", date.year());
      }

      return components;
    }
  }]);

  return NLRelativeDateFormatParser;
}(AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking);

exports.default = NLRelativeDateFormatParser;